import React, { Component, useEffect, useMemo, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Form from "../../comman/form";
import AddWorkingHrs from "./AddWorkingHrs";
import {
  getAllMonths,
  getAllYears,
  getDateOnly,
  getTotalHours,
  sanitizeEvent,
  sanitizeEventList,
  toLocalDate,
} from "../../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { addNewTmLog, getTmLogAddedStatus } from "../../app/store/timeLog";

const AddNewTimeLog = (props) => {
  const {
    showHide: tmShowHide,
    handleShowHide,
    viewType,
    selectedObj,
    allTimeLogs,
    candidateObj,
    timeLogInvoices,
    projectStartDate,
  } = props;

  const localizer = momentLocalizer(moment);

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [allEvents, setAllEvents] = useState([]);
  const [docType, setDocType] = useState("monthly");
  const [monthlyHrs, setMonthlyHrs] = useState("");
  const [chkMonthlyHrs, setChkMonthlyHrs] = useState("");
  const [monthlyDays, setMonthlyDays] = useState("");
  const [documents, setDocuments] = useState([]);
  const [wrkHrShowHide, setWrkHrShowHide] = useState(false);
  const [dtObj, setDtObj] = useState(null);
  const [currentWfTask, setCurrentWfTask] = useState(null);
  const [saveTmWithDocs, setSaveTmWithDocs] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [prjStartYear, setPrjStartYear] = useState(0);
  const [prjStartMonth, setPrjStartMonth] = useState(0);
  const [prjStartMonthDay, setPrjStartMonthDay] = useState(0);

  const tmLogAddedStatusSelector = useSelector(getTmLogAddedStatus);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (allTimeLogs.length > 0) {
      let events = [];
      allTimeLogs.forEach((t) => {
        if (!t.workingHrs) return;

        const wt = JSON.parse(t.workingHrs);

        wt.forEach((w) => {
          if (w.type === "m") return;
          const dt = toLocalDate(w.start);
          events.push({
            start: dt,
            end: dt,
            title: w.title,
          });
        });
      });

      setAllEvents(events);
    }
  }, [allTimeLogs]);

  useEffect(() => {
    if (selectedObj) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);
      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
      // if(candidateObj?.duration){
      //   const dur = new Date(candidateObj.duration?.startDate);
      //   console.log(dur, "dur")
      //   setPrjStartYear(dur.getFullYear());
      //   setPrjStartMonth(dur.getMonth() + 1);
      // }

      if (selectedObj.workingHrs) {
        // console.log(selectedObj, "selectedObj")
        try {
          const hrsArray = JSON.parse(selectedObj.workingHrs);
          if (hrsArray.length > 0) {
            const { title, days, type } = hrsArray[0];
            if (type) {
              if (title || days) {
                setChkMonthlyHrs("monthly");
                setMonthlyHrs(title);
                setMonthlyDays(days);
              }
            }
          }
        } catch (err) {
          console.error("Failed to parse workingHrs:", err);
        }
      }
    } else {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth();
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    if (projectStartDate) {
      const dur = new Date(projectStartDate);
      console.log(dur, "dur");
      setPrjStartYear(dur.getFullYear());
      setPrjStartMonth(dur.getMonth() + 1);
      setPrjStartMonthDay(dur.getDate());
    } else {
      setPrjStartYear(0);
      setPrjStartMonth(0);
    }
  }, [selectedObj]);

  const handleOnChange = ({ currentTarget }) => {
    const id = currentTarget.id.split("_")[1];
    const name = currentTarget.id.split("_")[0];
    const { timeLogs } = this.state;
    let obj = timeLogs.filter((x) => x.id === parseInt(id))[0];
    const index = timeLogs.findIndex((x) => x.id === parseInt(id));
    obj[name] = currentTarget.value;
    timeLogs[index] = obj;
    //this.setState({ timeLogs });
  };

  const doSubmit = (type) => {
    setSaveBtnProccess(true);
    if (type === "reset") setSelectedYear(null);
    const selectedTimeLog = allTimeLogs.filter(
      (x) =>
        x.year === parseInt(selectedYear) &&
        x.month === parseInt(selectedMonth),
    );
    if (selectedTimeLog.length > 0) {
      checkInvoiceStatus(selectedTimeLog);
    } else {
      saveTmLogs();
    }
  };

  const checkInvoiceStatus = (selectedTimeLog) => {
    const tmLog = selectedTimeLog[0];
    const invType = ["recruiter", "subcontractor"];
    const checkApproved = timeLogInvoices?.filter(
      (x) =>
        x.timeLogId === tmLog.id &&
        // x.invoiceType === invType &&
        invType.includes(x.invoiceType) &&
        x.status === true,
    );
    if (checkApproved.length > 0) {
      getAlert("", "Timelog is already Approved", "error");
    } else {
      saveTmLogs();
    }
  };

  const saveTmLogs = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you have entered the correct hours for the Week/Month?",
      "warning",
    );
    if (result.isConfirmed) {
      if (documents.length > 0) saveTmDocs();
      else saveTimeLogs(0);
    }
  };

  const saveTmDocs = async () => {
    const frmData = new FormData();
    frmData.append("message", "Time Sheet");
    frmData.append("workflowTask", JSON.stringify(currentWfTask));
    frmData.append("userId", currentUser.id);
    frmData.append("docType", docType + "_time_sheet");
    documents.map((file, key) =>
      frmData.append("files[" + key + "]", file.file),
    );
    //dispatch(uploadAppDocuments(frmData));
    setSaveTmWithDocs(true);
  };

  const saveTimeLogs = (docId) => {
    // Normalize mixed Date/string calendar events before filtering/saving.
    const normalizedEvents = sanitizeEventList(allEvents);

    // Filter events that belong to the selected month/year
    const filterEvents = normalizedEvents.filter((e) => {
      const [year, month] = getDateOnly(e.start).split("-").map(Number);

      return year === Number(selectedYear) && month === Number(selectedMonth);
    });

    const tmObj = {};

    // Handle MONTHLY HOURS mode
    if (chkMonthlyHrs === "monthly" && Number(monthlyHrs) > 0) {
      const selMonth =
        Number(selectedMonth) < 10
          ? "0" + Number(selectedMonth)
          : selectedMonth;

      const selDays = monthlyDays || 0;
      const formattedMonthlyHrs = monthlyHrs.toString().trim();

      const newEvents = [
        {
          start: `${selectedYear}-${selMonth}-01`,
          end: `${selectedYear}-${selMonth}-02`,
          title: formattedMonthlyHrs,
          type: "m",
          days: selDays,
        },
      ];

      tmObj["workingHrs"] = JSON.stringify(newEvents);
    }
    // DAILY MODE
    else {
      tmObj["workingHrs"] =
        filterEvents.length > 0 ? JSON.stringify(filterEvents) : null;
    }

    // Additional fields
    tmObj["candidateId"] = candidateObj.performerid;
    tmObj["subcontractorId"] = candidateObj.validId;
    tmObj["docId"] = docId;
    tmObj["docUploadType"] = docType;
    tmObj["year"] = Number(selectedYear);
    tmObj["month"] = Number(selectedMonth);

    if (selectedObj?.id > 0) {
      tmObj["id"] = selectedObj.id;
    }

    dispatch(addNewTmLog(tmObj));
  };

  useEffect(() => {
    if (tmLogAddedStatusSelector) {
      getAlert("", "Timelog Updated Successfully", "success");
      setSaveBtnProccess(false);
      handleShowHide("save");
    }
  }, [tmLogAddedStatusSelector]);

  const handleSelect = (wrkHr) => {
    if (!dtObj) return;

    const { start, end } = dtObj;

    // Always convert selected date into YYYY-MM-DD
    const selectedDate = getDateOnly(start);

    // Clean list (remove any events that have times)
    let updatedEvents = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find all events on this day
    const sameDayEvents = updatedEvents.filter((x) => x.start === selectedDate);

    if (sameDayEvents.length > 0) {
      // Take first one to update
      const target = sameDayEvents[0];
      const targetIndex = updatedEvents.indexOf(target);

      // Remove duplicates on same date (if any)
      if (sameDayEvents.length > 1) {
        sameDayEvents.slice(1).forEach((dupEv) => {
          const dupIndex = updatedEvents.indexOf(dupEv);
          if (dupIndex !== -1) updatedEvents.splice(dupIndex, 1);
        });
      }

      // Update the selected event
      updatedEvents[targetIndex] = {
        ...updatedEvents[targetIndex],
        title: wrkHr,
      };
    } else {
      // Add new event (date-only)
      updatedEvents.push({
        start: selectedDate,
        end: selectedDate,
        title: wrkHr,
      });
    }

    setAllEvents(updatedEvents);
    setWrkHrShowHide(false);
    setDtObj(null);
  };

  const handleeEditSelect = (wrkHr) => {
    if (!dtObj) return;

    // Always sanitize date fields from dtObj
    const targetStart = getDateOnly(dtObj.start);
    const targetEnd = getDateOnly(dtObj.end);
    const targetTitle = dtObj.title;

    // Always sanitize event list to keep everything date-only
    const events = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find correct event (safe for USA/India timezones)
    const index = events.findIndex((x) => {
      return (
        x.start === targetStart &&
        x.end === targetEnd &&
        x.title === targetTitle
      );
    });

    if (index === -1) return; // No match found

    // Update the found event immutably
    const updatedEvents = [...events];
    updatedEvents[index] = {
      ...updatedEvents[index],
      title: wrkHr,
    };

    setAllEvents(updatedEvents);
  };

  const handleYearChange = ({ currentTarget }) => {
    setSelectedYear(currentTarget.value);
    const newDt = new Date(currentTarget.value, selectedMonth - 1, 1);
    setSelectedDate(newDt);
  };

  const handleMonthChange = ({ currentTarget }) => {
    if (prjStartYear === selectedYear && currentTarget.value < prjStartMonth) {
      getAlert(
        "",
        `Month should be greater than or equal to ${months.find((x) => x.id === prjStartMonth).name}`,
        "error",
      );
      return;
    }
    setSelectedMonth(currentTarget.value);
    const newDt = new Date(selectedYear, currentTarget.value - 1, 1);
    setSelectedDate(newDt);
  };

  const handleDateChanged = (date) => {
    // Extract safe local date (prevents timezone shift)
    const getLocalDateParts = (d) => {
      const dt = new Date(d);
      return {
        year: dt.getFullYear(),
        month: dt.getMonth(), // 0-based
        day: dt.getDate(),
        full: dt,
      };
    };

    const { year, month, full } = getLocalDateParts(date);

    const cyear = new Date().getFullYear();
    const cmonth = new Date().getMonth();

    const findYear = years.filter((x) => x.name === year);

    if (
      (year === cyear && month <= cmonth && findYear.length > 0) ||
      (year < cyear && findYear.length > 0)
    ) {
      setSelectedYear(year);
      setSelectedMonth(month + 1); // convert 0-based → 1-based
      setSelectedDate(full); // safe Date object
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (let file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleWrkHrShowHide = (obj) => {
    if (!obj) {
      setWrkHrShowHide(false);
      setDtObj(null);
      return;
    }

    const dt = new Date(obj.start); // Date user clicked

    // If this is a slot click (outside the green card) but an event already exists for this date,
    // use the event object instead so the logged hours are populated for editing.
    if (obj && !obj.title) {
      const clickedDateStr = getDateOnly(dt);
      const matchedEvents = allEvents.filter(
        (ev) => getDateOnly(ev.start) === clickedDateStr
      );
      if (matchedEvents.length > 0) {
        obj = matchedEvents[0];
      }
    }
    const now = new Date();

    // Compare only the date (ignore time)
    const currentDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
    );
    const targetDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

    // 🔢 Convert all year/month/day values to numbers
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    if (dt.getMonth() + 1 !== selectedMonthNum) return;

    const showError = (msg) => getAlert("", msg, "error");

    // --- 1️⃣ Block: Before project start ---
    if (
      selectedYearNum < prjStartYearNum ||
      (selectedYearNum === prjStartYearNum &&
        selectedMonthNum < prjStartMonthNum)
    ) {
      return showError(
        "You cannot add working hours for months before the project start date.",
      );
    }

    // --- 🆕 Additional Day Check for Project Start Month ---
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum
    ) {
      if (dt.getDate() < prjStartMonthDayNum) {
        return showError(
          `You cannot add working hours before the project start date (${prjStartMonthDayNum}/${prjStartMonthNum}/${prjStartYearNum}).`,
        );
      }
    }

    // --- 2️⃣ Block: Future months ---
    if (
      selectedYearNum > currentYear ||
      (selectedYearNum === currentYear && selectedMonthNum > currentMonth)
    ) {
      return showError("You cannot add working hours for future months.");
    }

    // --- 3️⃣ Current month handling ---
    if (selectedYearNum === currentYear && selectedMonthNum === currentMonth) {
      if (targetDate > currentDate) {
        return showError("You cannot add working hours for future dates.");
      }

      // ✅ Allow today and past dates in current month
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 4️⃣ Past months (after project start, before current month) ---
    if (
      (selectedYearNum > prjStartYearNum ||
        (selectedYearNum === prjStartYearNum &&
          selectedMonthNum >= prjStartMonthNum)) &&
      (selectedYearNum < currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum < currentMonth))
    ) {
      // ✅ Allow all days in past months (after start)
      setWrkHrShowHide((prev) => !prev);
      setDtObj(obj);
      return;
    }

    // --- 5️⃣ Fallback ---
    showError("Unable to add working hours for this date.");
  };

  const handleChkMonthly = ({ target }) => {
    if (target.checked) {
      setChkMonthlyHrs("monthly");
    } else {
      setChkMonthlyHrs("");
    }
  };

  const handleReset = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Reset the entered hours for the week(s)/month?",
      "warning",
    );

    if (!result.isConfirmed) return;

    // Restore header fields
    if (selectedObj?.id > 0) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);

      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
    } else {
      const dt = new Date();
      setSelectedYear(dt.getFullYear());
      setSelectedMonth(dt.getMonth() + 1);
      setSelectedDate(dt);

      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    // Build event list safely (with dateUtils)
    const events = [];

    allTimeLogs.forEach((t) => {
      if (!t.workingHrs) return;

      const wt = JSON.parse(t.workingHrs);

      wt.forEach((w) => {
        // Convert any format → YYYY-MM-DD safely
        const cleanEvent = sanitizeEvent({
          start: w.start,
          end: w.start,
          title: w.title,
        });

        events.push(cleanEvent);
      });
    });

    setAllEvents(events);
    getAlert("", "Reset Successfully", "success");
  };

  const loggedHoursByDate = useMemo(() => {
    return allEvents.reduce((acc, event) => {
      const dateKey = getDateOnly(event?.start);
      if (dateKey) acc[dateKey] = event?.title;
      return acc;
    }, {});
  }, [allEvents]);

  const isBlockedCalendarDate = (date) => {
    const calendarDate = new Date(date);
    const today = new Date();
    const targetDate = new Date(
      calendarDate.getFullYear(),
      calendarDate.getMonth(),
      calendarDate.getDate(),
    );
    const currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    if (calendarDate.getMonth() + 1 !== selectedMonthNum) return true;
    if (targetDate > currentDate) return true;
    if (!prjStartYearNum || !prjStartMonthNum) return false;
    if (selectedYearNum < prjStartYearNum) return true;
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum < prjStartMonthNum
    )
      return true;
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum &&
      calendarDate.getDate() < prjStartMonthDayNum
    )
      return true;

    return false;
  };

  const dayPropGetter = (date) => {
    const dateKey = getDateOnly(date);
    const classes = ["time-log-day-cell"];

    if (loggedHoursByDate[dateKey]) classes.push("time-log-day-cell--logged");
    if (moment(date).isSame(new Date(), "day"))
      classes.push("time-log-day-cell--today");
    if (date.getMonth() + 1 !== parseInt(selectedMonth, 10))
      classes.push("time-log-day-cell--outside");
    if (isBlockedCalendarDate(date)) classes.push("time-log-day-cell--blocked");

    return { className: classes.join(" ") };
  };

  const CalendarEventCard = ({ event, onClick }) => (
    <div
      className="time-log-entry-card"
      onClick={onClick}
      onMouseDown={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
      role="button"
      tabIndex={0}
    >
      <div className="time-log-entry-accent" aria-hidden="true"></div>
      <div className="time-log-entry-body">
        <div className="time-log-entry-status">
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          {event?.title || "0"} Hour(s)
        </div>
      </div>
    </div>
  );

  const CalendarDateHeader = ({ date, label, isOffRange }) => {
    const dateKey = getDateOnly(date);
    const loggedHours = loggedHoursByDate[dateKey];
    const loggedEvent = allEvents.find(
      (event) => getDateOnly(event?.start) === dateKey,
    );
    const isToday = moment(date).isSame(new Date(), "day");
    const isBlocked = isBlockedCalendarDate(date);

    return (
      <div
        className={[
          "time-log-date-header",
          loggedHours ? "time-log-date-header--logged" : "",
          isToday ? "time-log-date-header--today" : "",
          isOffRange ? "time-log-date-header--off-range" : "",
          isBlocked ? "time-log-date-header--blocked" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="time-log-date-top">
          <span className="time-log-date-number">{label}</span>
        </div>
        {loggedHours && !isOffRange && (
          <CalendarEventCard
            event={{
              title: loggedHours,
              start: date,
            }}
            onClick={(clickEvent) => {
              clickEvent.preventDefault();
              clickEvent.stopPropagation();
              if (isBlocked) return;
              const eventForPopup = {
                ...(loggedEvent || {}),
                start: loggedEvent?.start || date,
                end: loggedEvent?.end || loggedEvent?.start || date,
                title: loggedEvent?.title ?? loggedHours,
              };
              handleWrkHrShowHide(eventForPopup);
            }}
          />
        )}
      </div>
    );
  };

  const eventStyleGetter = (event) => {
    const style = {
      background: "transparent",
      border: "0",
      boxShadow: "none",
      color: "transparent",
      height: 0,
      minHeight: 0,
      opacity: 0,
      padding: 0,
      pointerEvents: "none",
    };
    return {
      style,
    };
  };

  let filterMonths = months.filter((x) => x.id <= new Date().getMonth() + 1);
  if (selectedYear < new Date().getFullYear()) filterMonths = months;

  return (
    <>
      <style>{`
        /* Modal Customization */
        .modal-content {
          border-radius: 20px !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 24px 48px -12px rgba(15, 23, 42, 0.18) !important;
          overflow: hidden;
          background: #ffffff;
        }

        .modal-header {
          background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
          border-bottom: 1px solid #e2e8f0;
          padding: 20px 28px !important;
        }

        .modal-title {
          font-size: 18px !important;
          font-weight: 800 !important;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .modal-body {
          padding: 28px !important;
          background: #ffffff;
          border: none !important;
        }

        .modal-footer {
          background: #f8fafc;
          border-top: 1px solid #e2e8f0;
          padding: 18px 28px !important;
          gap: 12px;
        }

        /* Form Controls */
        .wf-form-group {
          margin-bottom: 20px;
        }

        .wf-form-label {
          font-size: 12px;
          font-weight: 800;
          color: #64748b;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-bottom: 8px;
          display: block;
        }

        /* Select wrapper with prepended icon */
        .wf-select-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
        }

        .wf-select-icon {
          position: absolute;
          left: 14px;
          color: #64748b;
          font-size: 14px;
          pointer-events: none;
          z-index: 2;
          transition: color 0.2s ease;
        }

        .wf-select-wrapper:focus-within .wf-select-icon {
          color: #2563eb !important;
        }

        .wf-control-select, .wf-control-input {
          height: 42px;
          width: 100%;
          border-radius: 12px !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 0 16px 0 38px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          outline: none !important;
        }

        .wf-control-select {
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
          appearance: none !important;
          -webkit-appearance: none !important;
        }

        .wf-control-select:hover, .wf-control-input:hover {
          border-color: #cbd5e1 !important;
          background-color: #fafbfc !important;
        }

        .wf-control-select:focus, .wf-control-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
          background-color: #ffffff !important;
        }

        /* Calendar Header Controls */
        .wf-calendar-controls-wrap {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .wf-control-select-compact {
          height: 36px;
          width: 105px;
          border-radius: 8px !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 0 20px 0 28px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 10px center / 8px 5px !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }

        .wf-control-select-compact:hover {
          border-color: #cbd5e1 !important;
          background-color: #fafbfc !important;
        }

        .wf-control-select-compact:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          background-color: #ffffff !important;
        }

        .wf-select-icon-compact {
          position: absolute;
          left: 10px;
          color: #64748b;
          font-size: 12px;
          pointer-events: none;
          z-index: 2;
          transition: color 0.2s ease;
        }

        .wf-hours-card-compact {
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          border: 1.5px solid rgba(191, 219, 254, 0.8);
          border-radius: 8px;
          padding: 0 14px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-shadow: 0 2px 8px rgba(37, 99, 235, 0.01);
          transition: all 0.2s ease;
        }

        .wf-hours-card-compact:hover {
          border-color: rgba(37, 99, 235, 0.4);
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.03);
          transform: translateY(-1px);
        }

        /* Calendar Top Row from customer portal */
        .wf-calendar-top-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
          margin-bottom: 16px;
          padding: 0 4px;
        }

        .wf-calendar-heading-wrap {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wf-calendar-badge {
          width: 44px;
          height: 44px;
          border-radius: 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(79,70,229,0.16) 100%);
          color: #4338ca;
          border: 1px solid rgba(191, 219, 254, 1);
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
          font-size: 18px;
        }

        .wf-calendar-heading-title {
          font-size: 15px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 2px;
        }

        .wf-calendar-heading-text {
          font-size: 12.5px;
          color: #64748b;
          line-height: 1.5;
        }

        .wf-calendar-hint {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          border-radius: 999px;
          border: 1px solid rgba(191, 219, 254, 1);
          background: #eff6ff;
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 700;
        }

        .wf-calendar-wrap {
          height: auto;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          overflow: hidden;
          background: #f8fafc;
          padding: 20px;
        }

        /* Calendar Styles from Customer Portal */
        .add-time-log-calendar .rbc-calendar {
          height: auto !important;
          background: transparent;
          color: #0f172a;
          font-family: inherit;
        }
        .add-time-log-calendar .rbc-toolbar {
          margin-bottom: 14px;
          gap: 10px;
          flex-wrap: wrap;
        }
        .add-time-log-calendar .rbc-toolbar-label {
          font-size: 18px;
          font-weight: 800;
          color: #0f172a;
        }
        .add-time-log-calendar .rbc-btn-group {
          display: inline-flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }
        .add-time-log-calendar .rbc-btn-group button {
          border-radius: 999px;
          border: 1px solid rgba(191, 219, 254, 1);
          background: #ffffff;
          color: #475569;
          font-size: 12px;
          font-weight: 700;
          padding: 7px 12px;
          box-shadow: 0 6px 16px rgba(15, 23, 42, 0.04);
          margin: 0;
          min-width: 80px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .add-time-log-calendar .rbc-btn-group button.rbc-active,
        .add-time-log-calendar .rbc-btn-group button:hover,
        .add-time-log-calendar .rbc-btn-group button:focus {
          background: #eff6ff;
          color: #1d4ed8;
          border-color: rgba(191, 219, 254, 1);
          box-shadow: 0 8px 18px rgba(37, 99, 235, 0.08);
        }
        .add-time-log-calendar .rbc-month-view {
          height: auto !important;
          flex: none !important;
          border-radius: 12px !important;
          overflow: hidden !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          background: #ffffff !important;
          box-shadow: none !important;
        }
        .add-time-log-calendar .rbc-header {
          border-bottom: 1px solid rgba(226, 232, 240, 1) !important;
          padding: 12px 6px !important;
          background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%) !important;
          color: #64748b !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .add-time-log-calendar .rbc-month-row + .rbc-month-row {
          border-top: 1px solid rgba(226, 232, 240, 0.8) !important;
        }
        .add-time-log-calendar .rbc-month-row {
          height: 84px !important;
          flex: none !important;
          overflow: visible !important;
        }
        .add-time-log-calendar .rbc-day-bg + .rbc-day-bg,
        .add-time-log-calendar .rbc-header + .rbc-header {
          border-left: 1px solid rgba(226, 232, 240, 0.7) !important;
        }
        .add-time-log-calendar .rbc-day-bg {
          background: transparent !important;
          cursor: pointer !important;
        }
        .add-time-log-calendar .rbc-day-bg::after {
          display: none !important;
        }
        .add-time-log-calendar .rbc-date-cell {
          padding: 5px 6px !important;
          text-align: left !important;
          cursor: pointer !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: stretch !important;
          height: 100% !important;
          overflow: visible !important;
        }
        .add-time-log-calendar .rbc-date-cell > a {
          display: none !important;
        }
        .add-time-log-calendar .time-log-date-header {
          height: 72px !important;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: stretch;
          position: relative;
          z-index: 3;
          width: 100% !important;
          border-radius: 18px;
          padding: 8px 8px 8px 8px; /* Compact padding to maximize horizontal space */
          background: #ffffff;
          border: 1.5px solid #f1f5f9;
          box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.02), 0 2px 4px -1px rgba(15, 23, 42, 0.01);
          transition: transform 220ms cubic-bezier(0.34, 1.56, 0.64, 1), border-color 220ms ease, box-shadow 220ms ease, background-color 220ms ease;
          box-sizing: border-box;
        }
        .add-time-log-calendar .time-log-date-header::before {
          display: none !important;
        }
        .add-time-log-calendar .time-log-date-header--logged {
          border-color: #d1f2e5 !important;
          background: #ffffff !important;
          box-shadow: 0 4px 10px -2px rgba(16, 185, 129, 0.04) !important;
        }
        .add-time-log-calendar .time-log-date-header--today {
          border-color: #bfdbfe !important;
          background: #ffffff !important;
          box-shadow: 0 4px 10px -2px rgba(37, 99, 235, 0.04) !important;
        }
        .add-time-log-calendar .time-log-date-header--blocked {
          background: #f8fafc !important;
          border-color: #e2e8f0 !important;
          border-style: dashed !important;
          opacity: 0.65 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }
        .add-time-log-calendar .time-log-date-header--off-range {
          background: #f8fafc !important;
          border-color: #f1f5f9 !important;
          border-style: dashed !important;
          opacity: 0.4 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header {
          transform: translateY(-2px) !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 12px 22px -8px rgba(15, 23, 42, 0.08), 0 4px 12px -4px rgba(15, 23, 42, 0.03) !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--logged {
          border-color: #10b981 !important;
          box-shadow: 0 14px 26px -8px rgba(16, 185, 129, 0.16), 0 8px 16px -8px rgba(16, 185, 129, 0.08) !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--today {
          border-color: #2563eb !important;
          box-shadow: 0 14px 26px -8px rgba(37, 99, 235, 0.16), 0 8px 16px -8px rgba(37, 99, 235, 0.08) !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--blocked,
        .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--off-range {
          transform: none !important;
          box-shadow: none !important;
          background: #f1f5f9 !important;
        }
        .add-time-log-calendar .time-log-date-top {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-bottom: 6px;
        }
        .add-time-log-calendar .time-log-date-number {
          font-size: 18px;
          font-weight: 800;
          color: #64748b;
          line-height: 1;
          transition: color 180ms ease;
        }
        .add-time-log-calendar .time-log-date-header--logged .time-log-date-number {
          color: #065f46 !important;
        }
        .add-time-log-calendar .time-log-date-header--today .time-log-date-number {
          color: #2563eb !important;
        }
        .add-time-log-calendar .time-log-date-header--blocked .time-log-date-number,
        .add-time-log-calendar .time-log-date-header--off-range .time-log-date-number {
          color: #cbd5e1 !important;
        }
        .add-time-log-calendar .rbc-off-range-bg {
          background: #f8fafc !important;
        }
        .add-time-log-calendar .rbc-off-range .rbc-date-cell > a {
          color: #cbd5e1 !important;
        }
        .add-time-log-calendar .rbc-today {
          background: transparent !important;
        }
        .add-time-log-calendar .rbc-month-row .rbc-row-content {
          z-index: 2;
          overflow: visible !important;
          height: 100% !important;
        }
        .add-time-log-calendar .rbc-month-row .rbc-row-content,
        .add-time-log-calendar .rbc-month-row .rbc-row {
          overflow: visible !important;
          height: 100% !important;
        }
        .add-time-log-calendar .rbc-row-segment {
          padding: 0;
        }
        .add-time-log-calendar .rbc-event {
          display: none !important;
        }
        .add-time-log-calendar .rbc-event:focus {
          outline: none;
        }
        .add-time-log-calendar .rbc-selected {
          background: transparent;
        }
        .add-time-log-calendar .rbc-event-content {
          display: none !important;
        }
        .add-time-log-calendar .time-log-entry-card {
          width: 100%;
          min-height: 30px;
          border-radius: 10px !important;
          background: #e6f6f0 !important; /* Light green full width background */
          box-shadow: 0 2px 5px rgba(16, 185, 129, 0.04) !important;
          border: 1px solid rgba(16, 185, 129, 0.2) !important;
          border-left: 4px solid #10b981 !important; /* Border is card left side border */
          display: flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 3px 8px !important;
          overflow: hidden;
          cursor: pointer;
          margin-top: auto;
          box-sizing: border-box;
          transition: border-color 220ms ease, background-color 220ms ease, box-shadow 220ms ease, transform 220ms cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .add-time-log-calendar .time-log-entry-card:focus {
          outline: 2px solid rgba(37, 99, 235, 0.22);
          outline-offset: 2px;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-entry-card {
          border-color: rgba(16, 185, 129, 0.3) !important;
          border-left-color: #059669 !important;
          background: #dcf7ef !important;
          box-shadow: 0 6px 12px rgba(16, 185, 129, 0.08) !important;
          transform: scale(1.02) !important;
        }
        .add-time-log-calendar .time-log-entry-accent {
          display: none !important; /* Hide old inner vertical bar */
        }
        .add-time-log-calendar .time-log-entry-body {
          flex-grow: 1;
          display: flex;
          align-items: center;
          min-width: 0;
        }
        .add-time-log-calendar .time-log-entry-status {
          margin-top: 0;
          min-height: auto;
          border-radius: 0 !important;
          background: transparent !important; /* Transparent background */
          color: #065f46 !important;
          border: none !important;
          box-shadow: none !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: flex-start !important;
          gap: 5px !important;
          padding: 0 !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          white-space: nowrap !important;
          transition: color 220ms ease !important;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-entry-status {
          color: #047857 !important;
        }
        .add-time-log-calendar .time-log-entry-status i {
          color: #10b981 !important;
          font-size: 10.5px !important;
          transition: transform 0.2s ease;
        }
        .add-time-log-calendar .rbc-date-cell:hover .time-log-entry-status i {
          animation: timeLogClockWiggle 0.6s ease-in-out infinite alternate;
        }
        @keyframes timeLogClockWiggle {
          0% { transform: rotate(-8deg); }
          100% { transform: rotate(8deg); }
        }
        .add-time-log-calendar .rbc-show-more {
          color: #2563eb;
          font-size: 11px;
          font-weight: 700;
          background: transparent;
        }

        /* Custom Toggle Card for Non-Billable Staff */
        .wf-toggle-card {
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 20px;
          background: #f8fafc;
          margin-top: 24px;
        }

        .wf-toggle-header {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .wf-toggle-title {
          font-size: 14px;
          font-weight: 800;
          color: #334155;
          margin: 0;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        /* Modern switch checkbox */
        .wf-switch {
          position: relative;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          gap: 10px;
          user-select: none;
          margin-bottom: 0;
        }

        .wf-switch input {
          display: none;
        }

        .wf-switch-slider {
          width: 44px;
          height: 24px;
          background-color: #cbd5e1;
          border-radius: 999px;
          position: relative;
          transition: background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .wf-switch-slider::before {
          content: "";
          position: absolute;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background-color: #ffffff;
          top: 3px;
          left: 3px;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 2px 4px rgba(15, 23, 42, 0.1);
        }

        .wf-switch input:checked + .wf-switch-slider {
          background-color: #2563eb;
        }

        .wf-switch input:checked + .wf-switch-slider::before {
          transform: translateX(20px);
        }

        .wf-switch-label {
          font-size: 13.5px;
          font-weight: 700;
          color: #334155;
        }

        /* Alert Warning Box */
        .wf-alert-warning {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 16px 20px;
          border-radius: 14px;
          background: #fffbeb;
          border: 1px solid #fde68a;
          color: #92400e;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.5;
          margin-top: 24px;
        }

        .wf-alert-warning i {
          font-size: 16px;
          margin-top: 2px;
          color: #d97706;
        }

        /* Action Buttons */
        .wf-btn-save {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          height: 40px;
          padding: 0 20px;
          border-radius: 10px;
          border: 1px solid rgba(37, 99, 235, 0.15);
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
          color: #ffffff;
          font-size: 13.5px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s ease;
          outline: none;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
        }

        .wf-btn-save:hover:not(:disabled) {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
        }

        .wf-btn-save:active:not(:disabled) {
          transform: scale(0.97);
        }

        .wf-btn-save:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .wf-btn-reset-modal {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          height: 40px;
          padding: 0 20px;
          border-radius: 10px;
          border: 1px solid #cbd5e1;
          background: #ffffff;
          color: #475569;
          font-size: 13.5px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          outline: none;
        }

        .wf-btn-reset-modal:hover {
          background: #f8fafc;
          border-color: #94a3b8;
          color: #1e293b;
        }

        .wf-btn-reset-modal:active {
          transform: scale(0.97);
        }

        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-timelog-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-timelog-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-timelog-modal {
          --task-accent: #2563eb; /* Primary Blue for Add Time Log */
          --task-soft: #f8fafc;   /* Default soft gray background */
          max-width: 90% !important;
          width: 1200px !important;
        }

        .wf-timelog-modal .modal-content {
          border-radius: 12px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border: none !important;
        }

        .wf-timelog-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 24px 28px 20px 32px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-timelog-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }

        .wf-timelog-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 14px !important;
          width: 100% !important;
        }

        .wf-timelog-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }

        .wf-timelog-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-timelog-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }

        .wf-timelog-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .wf-timelog-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .wf-timelog-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .wf-timelog-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }

        .wf-timelog-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-timelog-modal .rt-modal-desc i {
          color: var(--task-accent) !important;
        }

        .wf-timelog-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 240px) !important;
          overflow-y: auto !important;
        }

        /* Prevent outer modal wrapper from showing page-level scrollbars */
        body.modal-open .modal:has(.wf-timelog-modal) {
          overflow-y: hidden !important;
        }

        /* Premium Header Close Button */
        .wf-timelog-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .wf-timelog-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .wf-timelog-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .wf-timelog-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .wf-timelog-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        /* Premium Modal Footer Close Button */
        .wf-timelog-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }

        .wf-timelog-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .wf-timelog-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          transform: translateY(-1px) !important;
        }
        .wf-timelog-modal .wf-modal-footer-close-btn:active {
          transform: translateY(0) !important;
        }
        .wf-timelog-modal .wf-modal-footer-close-btn i {
          font-size: 12px !important;
          color: #64748b !important;
        }
      `}</style>

      <Modal
        show={tmShowHide}
        size="xl"
        dialogClassName="wf-timelog-modal"
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i
                  className="rt-header-icon fa fa-calendar-check-o"
                  aria-hidden="true"
                />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Add Time Log</span>
                      <span className="rt-modal-title-badge">Portal</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Log,
                    edit, and review daily working hours.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleShowHide("")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="wf-calendar-top-row">
                <div className="wf-calendar-heading-wrap">
                  <div className="wf-calendar-badge">
                    <i className="fa fa-calendar-o" aria-hidden="true"></i>
                  </div>
                  <div>
                    <div className="wf-calendar-heading-title">
                      Daily Hours Calendar
                    </div>
                    <div className="wf-calendar-heading-text">
                      Pick any valid day in the selected month to log or update
                      working hours.
                    </div>
                  </div>
                </div>
                <div className="wf-calendar-controls-wrap">
                  <div className="wf-select-wrapper" style={{ width: "auto" }}>
                    <i className="fa fa-calendar wf-select-icon-compact"></i>
                    <select
                      name="year"
                      id="year"
                      className="wf-control-select-compact"
                      onChange={handleYearChange}
                      value={selectedYear}
                      aria-label="Year select"
                    >
                      <option value="">Year</option>
                      {years
                        .filter((x) => x.name <= new Date().getFullYear())
                        .map((y) => (
                          <option key={y.name} value={y.name}>
                            {y.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="wf-select-wrapper" style={{ width: "auto" }}>
                    <i className="fa fa-filter wf-select-icon-compact"></i>
                    <select
                      name="month"
                      id="month"
                      className="wf-control-select-compact"
                      onChange={handleMonthChange}
                      value={selectedMonth}
                      aria-label="Month select"
                    >
                      <option value="">Month</option>
                      {filterMonths.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="wf-hours-card-compact">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "6px",
                          background: "#ffffff",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#2563eb",
                          fontSize: "11px",
                          boxShadow: "0 2px 4px rgba(37, 99, 235, 0.04)",
                        }}
                      >
                        <i className="fa fa-clock-o"></i>
                      </div>
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#1e40af",
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                        }}
                      >
                        Total Hours Logged:
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 800,
                        color: "#1d4ed8",
                        marginLeft: "10px",
                      }}
                    >
                      {selectedObj?.workingHrs
                        ? getTotalHours(selectedObj.workingHrs)
                        : "0.00"}{" "}
                      hrs
                    </span>
                  </div>
                </div>
              </div>
              <div className="wf-calendar-wrap add-time-log-calendar">
                <Calendar
                  selectable
                  localizer={localizer}
                  events={allEvents}
                  date={selectedDate}
                  views={["month"]}
                  onSelectEvent={handleWrkHrShowHide}
                  onSelectSlot={handleWrkHrShowHide}
                  onNavigate={handleDateChanged}
                  eventPropGetter={eventStyleGetter}
                  dayPropGetter={dayPropGetter}
                  components={{
                    event: CalendarEventCard,
                    month: {
                      dateHeader: CalendarDateHeader,
                    },
                  }}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="wf-toggle-card">
                <div className="wf-toggle-header">
                  <label className="wf-switch" htmlFor="chkMonthlyHrs">
                    <input
                      name="chkMonthlyHrs"
                      id="chkMonthlyHrs"
                      type="checkbox"
                      onChange={handleChkMonthly}
                      value="monHrs"
                      checked={chkMonthlyHrs === "monthly"}
                    />
                    <span className="wf-switch-slider"></span>
                    <span className="wf-switch-label">
                      Check Monthly Hour(s) (For Non-billable staff)
                    </span>
                  </label>
                </div>

                {chkMonthlyHrs === "monthly" && (
                  <div className="row mt-3">
                    <div className="col-md-6 wf-form-group">
                      <label htmlFor="monthlyHrs" className="wf-form-label">
                        Enter Monthly Hour(s)
                      </label>
                      <div className="wf-select-wrapper">
                        <i className="fa fa-clock-o wf-select-icon"></i>
                        <input
                          type="number"
                          className="wf-control-input"
                          id="monthlyHrs"
                          name="monthlyHrs"
                          value={monthlyHrs}
                          placeholder="Enter Monthly Hours"
                          onChange={({ currentTarget }) =>
                            setMonthlyHrs(currentTarget.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6 wf-form-group">
                      <label htmlFor="monthlyDays" className="wf-form-label">
                        Enter Total Day(s)
                      </label>
                      <div className="wf-select-wrapper">
                        <i className="fa fa-calendar-check-o wf-select-icon"></i>
                        <input
                          type="number"
                          className="wf-control-input"
                          id="monthlyDays"
                          name="monthlyDays"
                          value={monthlyDays}
                          placeholder="Enter Total Days"
                          onChange={({ currentTarget }) =>
                            setMonthlyDays(currentTarget.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="wf-alert-warning">
                <i className="fa fa-exclamation-triangle"></i>
                <div>
                  <strong>Please note:</strong> Documents that are
                  password-protected or restricted from printing should not be
                  uploaded.
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {viewType !== "invoice" ? (
            <>
              <button
                type="button"
                className="wf-modal-footer-close-btn"
                onClick={() => handleShowHide("")}
              >
                <i className="fa fa-times" aria-hidden="true"></i> Close
              </button>
              <button
                type="button"
                className="wf-btn-reset-modal"
                onClick={handleReset}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i> Reset
              </button>

              <button
                type="button"
                className="wf-btn-save"
                onClick={() => doSubmit("save")}
                disabled={saveBtnProccess}
              >
                {saveBtnProccess ? (
                  <>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>{" "}
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="fa fa-check" aria-hidden="true"></i> Save
                  </>
                )}
              </button>
            </>
          ) : (
            <button
              type="button"
              className="wf-modal-footer-close-btn"
              onClick={() => handleShowHide("")}
            >
              <i className="fa fa-times" aria-hidden="true"></i> Close
            </button>
          )}
        </Modal.Footer>
      </Modal>
      {wrkHrShowHide && (
        <AddWorkingHrs
          handleShowHide={handleWrkHrShowHide}
          showHide={wrkHrShowHide}
          selectedObj={dtObj}
          handleSelect={handleSelect}
          handleeEditSelect={handleeEditSelect}
          allEvents={allEvents}
        ></AddWorkingHrs>
      )}
    </>
  );
};

export default AddNewTimeLog;
